import React from 'react'
import { SiteConfiguration } from '@matech/thebigpos-sdk'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import useSiteConfigurationByEntity, {
	UseSiteConfigurationByEntityTypeProps,
} from '../../../hooks/useSiteConfigurationByEntity'
import MobileSettingsForm, {
	MobileSettingsFormFieldValues,
} from './MobileSettingsForm'
import useUser from '../../../hooks/useUser'
import { useAlert } from '../../../hooks'

export type MobileSettingsProps = {
	entityType: UseSiteConfigurationByEntityTypeProps['entityType']
}

const MobileSettings = ({ entityType }: MobileSettingsProps) => {
	const { isSuperAdmin } = useUser()
	const { formatMessage } = useIntl()
	const { id } = useParams()
	const { query, update } = useSiteConfigurationByEntity({
		entityType,
		entityId: id ?? '',
	})
	const { alert } = useAlert()
	const siteConfiguration = query?.data?.siteConfiguration
	const inheritedSiteConfiguration =
		query?.data?.inheritedSiteConfiguration

	const mobileSettings =
		siteConfiguration?.mobileSettings ??
		inheritedSiteConfiguration?.mobileSettings

	const handleSubmitSuccess = async (
		data: MobileSettingsFormFieldValues
	) => {
		try {
			if (!siteConfiguration) return
			const updatedSiteConfiguration: SiteConfiguration = {
				...siteConfiguration,
				mobileSettings: {
					...siteConfiguration?.mobileSettings,
					...data,
				},
			}

			update.mutate(updatedSiteConfiguration)
			alert(
				formatMessage({
					id: 'mobile_settings.mobile_settings_updated_successfully',
				}),
				{
					severity: 'success',
				}
			)
		} catch (error) {
			alert(
				formatMessage({
					id: 'mobile_settings.error_updating_mobile_settings',
				}),
				{
					severity: 'error',
				}
			)
			alert(error, { severity: 'error' })
		}
	}

	const handleSubmitError = () => {
		alert(
			formatMessage({
				id: 'mobile_settings.error_updating_mobile_settings',
			}),
			{
				severity: 'error',
			}
		)
	}

	const disabled = !isSuperAdmin || entityType !== 'Corporate'

	return (
		<MobileSettingsForm
			initialValues={mobileSettings}
			onSubmitSuccess={handleSubmitSuccess}
			onSubmitError={handleSubmitError}
			disabled={disabled}
		/>
	)
}

export default MobileSettings
